import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportIssueModal from './ReportIssueModal';
import { useIssueReport } from './IssueReportProvider';

/*
 * The Report issue button for the screens that have no navbar: the workspace
 * chooser, Field Mode's gallery and editor headers, and the camera (a chip
 * beside its GPS and Notes chips -- the camera's bottom bar keeps its four
 * buttons). The navbar's own button is Layout's, an icon among its quick
 * actions. Each opens the same dialog.
 *
 *   style      the trigger's look, so it sits among its neighbours
 *   children   the trigger's content (default: ⚑ and the label)
 */
export const FlagIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="M4 22V4" />
    <path d="M4 4h12l-2 4 2 4H4" />
  </svg>
);

export default function ReportIssueButton({ style, className, children, testId = 'report-issue-open' }) {
  const { t } = useTranslation('issues');
  // The app's one dialog (IssueReportProvider), else one of its own.
  const shared = useIssueReport();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={className} style={style} title={t('tip.open')} aria-label={t('open')}
        aria-haspopup="dialog" data-testid={testId} onClick={() => (shared ? shared.openReport() : setOpen(true))}>
        {children ?? (<><span aria-hidden="true">⚑ </span>{t('open')}</>)}
      </button>
      {!shared && <ReportIssueModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
